import { Button, Grid, TextField } from '@mui/material'
import { TextField as FormikTextField } from 'formik-material-ui'
import InputMask from 'react-input-mask'
import { Field, Form, Formik } from 'formik'
import { isEqual } from 'lodash'
import { memo } from 'react'
import { metodoPrograma } from '../../../components/api'

const retornaLocalAtendimento = (u = []) => ({
  dsNome: u?.[1] || undefined,
  dsContato: u?.[2] || undefined,
  dsObservacoes: u?.[3] || undefined,
  dtInclusao: u?.[4] || undefined,
  dtConclusao: u?.[5] || undefined,
})

const Edicao = ({ dados, voltar }) => {
  const salva = async (values) => {
    const res = await metodoPrograma('salva', values)
    if (res.status) voltar()
  }

  return (
    <Formik
      initialValues={retornaLocalAtendimento(dados)}
      onSubmit={async (values, { setSubmitting }) => {
        await salva(values)
        setSubmitting(false)
      }}
    >
      {({ isSubmitting, submitForm }) => (
        <Form style={{ width: '100%', padding: 0 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Field
                component={FormikTextField}
                name="dsNome"
                label="Nome"
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              <Field name="dsContato">
                {({ field, meta }) => (
                  <InputMask
                    mask="(99) 99999-9999"
                    value={field.value || ''}
                    onChange={field.onChange}
                    onBlur={field.onBlur}
                    name={field.name}
                  >
                    {(inputProps) => (
                      <TextField
                        {...inputProps}
                        label="Contato"
                        fullWidth
                        margin="dense"
                        variant="outlined"
                        error={meta.touched && Boolean(meta.error)}
                        helperText={meta.touched && meta.error}
                      />
                    )}
                  </InputMask>
                )}
              </Field>
            </Grid>
            <Grid item xs={12}>
              <Field
                component={FormikTextField}
                name="dsObservacoes"
                label="Observações"
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <Field
                disabled
                component={FormikTextField}
                name="dtInclusao"
                label="Inclusão"
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={6}>
              <Field
                disabled
                component={FormikTextField}
                name="dtConclusao"
                label="Conclusão"
                fullWidth
                margin="dense"
                variant="outlined"
              />
            </Grid>
            <Grid
              item
              xs={12}
              style={{ display: 'flex', flexDirection: 'row-reverse' }}
            >
              <Button
                onClick={submitForm}
                disabled={isSubmitting}
                variant="contained"
                color="primary"
                style={{ margin: '5px' }}
              >
                Salvar
              </Button>
              <Button
                onClick={voltar}
                variant="contained"
                color="secondary"
                style={{ margin: '5px' }}
              >
                Cancelar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}

export default memo(Edicao, isEqual)
